import { ComponentsOverrides, ComponentsProps } from '@mui/material';

export const getMuiBreadcrumbsOverrides = (): ComponentsOverrides['MuiBreadcrumbs'] => ({});

export const getMuiBreadcrumbsDefaultProps = (): ComponentsProps['MuiBreadcrumbs'] => ({});
